import { render, staticRenderFns } from "./addTax.vue?vue&type=template&id=a29d427e&scoped=true&"
import script from "./addTax.vue?vue&type=script&lang=js&"
export * from "./addTax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a29d427e",
  null
  
)

export default component.exports